  <div class="modal-header">
    <h4 class="modal-title">
      {{ title | translate }}
    </h4>
  </div>
  <div class="modal-body pt-0"
       [formGroup]="editForm">
    <div class="modal-body-inner position-relative">
      <div class="mb-3 row" *ngIf="articleAlreadyExists">
        <span class="font-italic">
          {{'configureCustomArticlePopup.error.message.article_number_already_exists' | translate}}<br />
          {{'configureCustomArticlePopup.hint.edit_existing_article' | translate}}
        </span>
      </div>
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label  font-weight-bold">
          {{'configureCustomArticlePopup.label.custom_article_number' | translate}}: *
        </label>
        <div class="col-md">
          <input class="form-control"
                 appInputAutoFocus
                 spellcheck="false"
                 type="text"
                 [readonly]="isProductionUser"
                 [class.is-invalid]="editForm.controls.articleNumberInput.invalid && editForm.controls.articleNumberInput.touched"
                 formControlName="articleNumberInput">
          <div class="invalid-feedback">{{editForm.controls.articleNumberInput.errors?.messageKey | translate}}</div>
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label  font-weight-bold">
          {{'configureCustomArticlePopup.label.name' | translate}}
        </label>
        <div class="col-md">
          <input class="form-control"
                 type="text"
                 spellcheck="false"
                 [readonly]="isProductionUser"
                 [class.is-invalid]="editForm.controls.articleDescriptionInput.invalid"
                 formControlName="articleDescriptionInput">
        </div>
        <div class="invalid-feedback">{{editForm.controls.articleDescriptionInput.errors?.messageKey | translate}}</div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label font-weight-bold">
          {{'configureCustomArticlePopup.label.width' | translate}}: *
        </label>
        <div class="col-md-4">
          <div class="input-group">
            <input class="form-control"
                   type="text"
                   spellcheck="false"
                   [readonly]="isProductionUser"
                   [class.is-invalid]="editForm.controls.widthInput.invalid"
                   (inputEvent)="editForm.controls.widthInput.setValue($event)"
                   formControlName="widthInput"
                   inputRestricter="^[0-9\.,]*$">
            <div class="input-group-append"><span class="input-group-text">{{'global.unit.label.mm' | translate }}</span></div>
            <div class="invalid-feedback">{{editForm.controls.widthInput.errors?.messageKey | translate : {'0': editForm.controls.widthInput.errors?.param} }}</div>
          </div>
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label font-weight-bold">
          {{'configureCustomArticlePopup.label.height' | translate}}: *
        </label>
        <div class="col-md-4">
          <div class="input-group">
            <input class="form-control"
                   type="text"
                   spellcheck="false"
                   [readonly]="isProductionUser"
                   [class.is-invalid]="editForm.controls.heightInput.invalid"
                   (inputEvent)="editForm.controls.heightInput.setValue($event)"
                   formControlName="heightInput"
                   inputRestricter="^[0-9\.,]*$">
            <div class="input-group-append"><span class="input-group-text">{{'global.unit.label.mm' | translate }}</span></div>
            <div class="invalid-feedback">{{editForm.controls.heightInput.errors?.messageKey | translate : {'0': editForm.controls.heightInput.errors?.param} }}</div>
          </div>
        </div>
      </div>

        <div class="custom-article-image">
            <label class="height-label">{{'configureCustomArticlePopup.label.height_short' | translate}}</label>
            <label class="width-label">{{'configureCustomArticlePopup.label.width_short' | translate}}</label>
            <label class="depth-label">{{'configureCustomArticlePopup.label.depth_short' | translate}}</label>
            <img [src]="'ng-assets/pics/custom_article_icon.png'">
        </div>
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label font-weight-bold">
          {{'configureCustomArticlePopup.label.depth' | translate}}: *
        </label>
        <div class="col-md-4">
          <div class="input-group">
            <input class="form-control"
                   type="text"
                   spellcheck="false"
                   [readonly]="isProductionUser"
                   [class.is-invalid]="editForm.controls.depthInput.invalid"
                   (inputEvent)="editForm.controls.depthInput.setValue($event)"
                   formControlName="depthInput"
                   inputRestricter="^[0-9\.,]*$">
            <div class="input-group-append"><span class="input-group-text">{{'global.unit.label.mm' | translate }}</span></div>
            <div class="invalid-feedback">{{editForm.controls.depthInput.errors?.messageKey | translate : {'0': editForm.controls.depthInput.errors?.param} }}</div>
          </div>
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label font-weight-bold">
          {{'configureCustomArticlePopup.label.depthoffset' | translate}}: *
        </label>
        <div class="col-md-4">
          <div class="input-group">
            <input class="form-control"
                   type="text"
                   spellcheck="false"
                   [readonly]="isProductionUser"
                   [class.is-invalid]="editForm.controls.depthOffsetInput.invalid"
                   (inputEvent)="editForm.controls.depthOffsetInput.setValue($event)"
                   formControlName="depthOffsetInput"
                   inputRestricter="^[0-9\-.,]*$">
            <div class="input-group-append"><span class="input-group-text">{{'global.unit.label.mm' | translate }}</span></div>
            <div class="invalid-feedback">
                {{editForm.controls.depthOffsetInput.errors?.messageKey | translate : {'0': editForm.controls.depthOffsetInput.errors?.param} }}
            </div>
          </div>
        </div>
      </div>
      <div class="mb-3 row" *ngIf="imageUrl && !isProductionUser">
        <label  *ngIf="imageUrl" class="col-md-4 col-form-label font-weight-bold" [ngClass]="canLoadImage() ? '' : 'disabled'">
          {{'configureCustomArticlePopup.label.image' | translate }}:
        </label>
        <img *ngIf="imageUrl"
             class="ps-3"
            [attr.width.px]="imageContainerWidth"
            [attr.height.px]="imageContainerHeight"
            [src]="imageUrl"
             alt="uploaded image"/>
      </div>
      <div class="mb-3 row" *ngIf="!isProductionUser">
        <div  class="col-md-4">
          <label *ngIf="!imageUrl" class="form-label font-weight-bold" [ngClass]="canLoadImage() ? '' : 'disabled'">
            {{'configureCustomArticlePopup.label.image' | translate }}:
          </label>
        </div>
        <div class="col-md">
          <input class="form-control is-valid inputfile"
                 id="file"
                 name="file"
                 type="file"
                 accept="/*.jpeg, /*.jpg, /*.png"
                 (change)="imageUpload($event)">
          <label class="btn btn-primary col-md-12" for="file">
            <app-svg-icon type="export" size="medium-small"/>
            <span>{{'configureCustomArticlePopup.label.select_image' | translate}}</span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-secondary btn-cancel"
            type="button"
            (mousedown)="clearValidationAndClose()"
            (touchstart)="clearValidationAndClose()">{{'global.label.cancel' | translate}}
    </button>
    <button id="customarticle_save" class="btn btn-primary btn-forward"
            type="submit"
            *ngIf="!isProductionUser"
            [disabled]="editForm.invalid"
            (click)="submit()">
      {{'global.label.save' | translate}}
    </button>
  </div>
